import { useState } from 'react';
import { useOverlayState } from '@heroui/react';
import { useQueryClient } from '@tanstack/react-query';
import { updateMe } from '../api/user';
import { invalidateParkingLists } from '../lib/parking-query';
import { applyMeResponseToStore } from './useAuth';
import { useCurrentCondominium } from './useCurrentCondominium';
import { showErrorFromUnknown, showSuccess } from '../lib/toast';

export function useSwitchCondominium() {
  const { condominiums, condominium, canSwitch } = useCurrentCondominium();
  const queryClient = useQueryClient();
  const modal = useOverlayState();
  const [switching, setSwitching] = useState(false);

  const openModal = () => {
    if (!canSwitch) return;
    modal.open();
  };

  const handleSelect = async (slug: string) => {
    if (condominium?.slug === slug) {
      modal.close();
      return;
    }

    setSwitching(true);
    try {
      const me = await updateMe({ lastSelectedTenantSlug: slug });
      applyMeResponseToStore(me);
      await invalidateParkingLists(queryClient);
      showSuccess('Condomínio alterado.');
      modal.close();
    } catch (err) {
      showErrorFromUnknown(err);
    } finally {
      setSwitching(false);
    }
  };

  return {
    modal,
    switching,
    condominiums,
    condominium,
    canSwitch,
    openModal,
    handleSelect,
    canOpenModal: canSwitch,
  };
}
